import { UploadFile } from 'antd/lib';
import { PjmSeasonDto } from '../season/PjmSeasonDto';
import { PjmRegistrationDto } from '../dto/PjmRegistrationDto';

export enum MeterDataUploadStatus {
    READY_TO_GENERATE = 'ready_to_generate', // triggered to generate file from interval data
    PENDING = 'pending', // file placed to upload
    DONE = 'done', // file was successfully uploaded
    FAILED = 'failed', // file was not uploaded, due to some error
}

export enum MeterDataUploadType {
    manual = 'manual',
    automated = 'automated',
}

export interface IPjmMeterDataFile {
    key: string;
    original_name: string;
    date_created: string;
    date_modified: string;
}

export interface IPjmMeterDataUpload {
    uuid: string;
    meter_data_file: IPjmMeterDataFile;
    is_calculate_winter_peak_load: boolean;
    uploadType: MeterDataUploadType;
    status: MeterDataUploadStatus;
    error_message?: string;

    seasonId?: string;
    season?: PjmSeasonDto;

    registrationId?: number;
    registration?: PjmRegistrationDto;

    actor: string;
    date_created: string;
    date_modified: string;
}

export interface ICreateMeterDataUpload {
    is_calculate_winter_peak_load: boolean;
    file?: UploadFile;
}

export interface IScheduleMeterDataUploadFileGeneration {
    registrationUuid: string;
    seasonId: string;
    isCalculateWinterPeakLoad: boolean;
}
